import { render } from "./ModalArticle.vue?vue&type=template&id=25619905&scoped=true"
import script from "./ModalArticle.vue?vue&type=script&lang=js"
export * from "./ModalArticle.vue?vue&type=script&lang=js"

import "./ModalArticle.vue?vue&type=style&index=0&id=25619905&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25619905"]])

export default __exports__